import { useQuery } from '@tanstack/react-query';
import { fetchRegistrations } from '../api/eventDetailsApi';

export const registrationsQueryKey = (
  eventCode: string | undefined,
  accountCode: string | undefined,
) => ['event-details', eventCode, accountCode, 'registrations'] as const;

export function useRegistrations(eventCode: string | undefined, accountCode: string | undefined) {
  return useQuery({
    queryKey: registrationsQueryKey(eventCode, accountCode),
    queryFn: () => fetchRegistrations({ eventCode: eventCode!, accountCode: accountCode! }),
    enabled: !!eventCode && !!accountCode,
  });
}